import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { produce } from 'immer';
import { Consts } from '@shared/consts';
import { IKeyValuePair } from '@interfaces/IKeyValuePair';

export interface CompanySoftwareOptionsState {
	companySoftwareOptions: IKeyValuePair;
	lastUpdate: Date;
}

export function createInitialState(): CompanySoftwareOptionsState {
	return {
		companySoftwareOptions: {},
		lastUpdate: null as Date
	};
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: Consts.CompanySoftwareOptionsName, producerFn: produce })
export class CompanySoftwareOptionsStore extends Store<CompanySoftwareOptionsState> {
	constructor() {
		super(createInitialState());
	}
}
